<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="名称">
              <el-input v-model="searchCondition.name" placeholder="输入账户名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row style="height: 36px">
          <ScreeCompany :allowField="allowField" @ScreeCompany="ScreeCompany" />
        </el-row>
        <ApeTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
        <el-table-column
          slot="first-column"
          align="center"
          label="公司名称"
          width="300px">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.id" placement="top">
              <div>{{ scope.row.company_name }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column
          slot="first-column"
          width="180"
          align="center"
          label="ID">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column> -->
        <el-table-column
          slot="second-column"
          width="100"
          align="center"
          label="合同">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="mxPreview(scope.row.file_url)">
                <i class="iconfont iconwenjian iconbtn iconBtns" @click="downButton(scope.row)"></i>
              </el-button>
              <el-button size="mini" type="text" @click="mxGoUrl(scope.row.file_url)">
                <i class="iconfont iconxiazai iconbtn iconBtns"></i>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            v-if="buttonType=='text'"
            width="160"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <span>
                <el-popover
                  placement="top"
                  width="150"
                  v-if="scope.row.status != 2"
                  v-model="scope.row.visible">
                  <p>确定要拒绝吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="viewButton(scope.row.id, '2')">确定</el-button>
                  </div>
                  <el-button slot="reference" size="mini" type="danger" v-if="scope.row.status == 0">拒绝</el-button>
                </el-popover>
                <el-popover
                  placement="top"
                  width="150"
                  v-if="scope.row.status != 1"
                  v-model="scope.row.visiblePass">
                  <p>确定要通过吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visiblePass=false">取消</el-button>
                    <el-button type="primary" size="mini" @click="viewButton(scope.row.id, '1')">确定</el-button>
                  </div>
                  <el-button slot="reference" size="mini" type="primary" v-if="scope.row.status == 0">通过</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="dialogRules" ref="companyAttacmentForm" label-position="right" label-width="96px">
          <el-form-item label="名称" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="intro">
            <el-input type="textarea" v-model="formData.intro"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
    <verification
      @dialogChanged="dialogBillChanged($event)"
      @onSuccess="handleBillSuccess($event)"
      :dialogBillVisible="dialogBillVisible"
      :billId="billId" />
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import Verification from '@/components/Verification.vue'
import ScreeCompany from '@/components/ScreeCompany.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker,
    Verification,
    ScreeCompany
  },
  data() {
    return {
      // 允许显示的字段
      allowField: ['companyId'],
      billId: '',
      dialogBillVisible: false,
      source: 'saas',
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCategory: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: false,
      columns: [
        // {
        //   title: '公司名称',
        //   value: 'company_name',
        //   header_align: 'center',
        //   align: 'center',
        //   // width: 200
        // },
        {
          title: '上传人',
          width: 200,
          value: 'fullname',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '上传时间',
          value: 'created_at',
          // width: 200,
          header_align: 'center',
          align: 'center',
        },
        {
          title: '更新时间',
          value: 'updated_at',
          // width: 200,
          header_align: 'center',
          align: 'center',
        },
        {
          title: '状态',
          width: 200,
          header_align: 'center',
          align: 'center',
          value: 'alias_status'
        },
      ],
      // 表格列表数据
      dataList:[
        // {
        //   id: '23241241',
        //   dilist: '五月份结算单',
        //   price: '100.00',
        //   bill_name: '市场推广',
        //   bill_desc: '提供推广服务',
        //   submit_time: '2017/02/11',
        //   alias_status: '审核中'
        // },
        // {
        //   id: '23241241',
        //   dilist: '五月份结算单',
        //   price: '100.00',
        //   bill_name: '市场推广',
        //   bill_desc: '提供推广服务',
        //   submit_time: '2017/02/11',
        //   alias_status: '审核中'
        // },
        // {
        //   id: '23241241',
        //   dilist: '五月份结算单',
        //   price: '100.00',
        //   bill_name: '市场推广',
        //   bill_desc: '提供推广服务',
        //   submit_time: '2017/02/11',
        //   alias_status: '审核中'
        // }
      ],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentCompanyId:0,
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
    ScreeCompany(v, name) {
      if(name == 'company') {
        if (v) {
          this.searchCondition.company_id = v
        } else {
          delete this.searchCondition.company_id
        }
        this.init('search')
      }else if(name == 'settlement') {
        if (v) {
          this.searchCondition.settlement_id = v
        } else {
          delete this.searchCondition.settlement_id
        }
        this.init('search')
      }
    },
    //切换系统
    changeSelc() {
      console.log(this.source, "saas")
    },
    // 搜索
    searchButton() {
      this.init()
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    // 响应添加按钮
    async addButton() {
      this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id, type) {
      this.formData.id = id
      this.formData.type = type
      this.formSubmit()
    },
    handleBillSuccess() {
      this.$message.success('验证成功')
    },
    // 响应编辑按钮
    async editButton(id) {
      console.log(id)
      this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      console.log(id)
    },
     //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    // 初始化列表
    async init(type) {
      if(type) {
        this.mxResetPage()
      }
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {list,pages}= await this.$api.getAdminContractList(searchCondition)
      this.dataList = []
      this.$nextTick(() => {
        this.dataList=list
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.id) {
        condition.id = this.searchCondition.id
      }
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      if(this.searchCondition.company_id || this.searchCondition.settlement_id) {
        condition.company_id = this.searchCondition.company_id
        condition.settlement_id = this.searchCondition.settlement_id
      }
      return condition
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      let id = await this.$api.saveAdminContractAudit(this.formData)
      this.$nextTick(() => {
        this.dialogClose()
      })
      this.$nextTick(() => {
        if (id) {
          this.$message.success('保存成功!')
          this.init()
        }
      })

    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyAttacmentForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
      this.attachmentUploadFileList = []
    },
    // 响应添加附件按钮
    async addAttachment() {
      this.dialogData.visible = true
      this.dialogData.loading = false
      this.dialogData.title = '添加附件'
    },
    // 相应删除文章附件按钮
    async deleteCompanyAttachmentButton(id) {
      let info = await this.$api.deleteCompanyAttachment(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.init()
        })
      } else {
        this.$message.error(info)
      }

    },
    keyupSubmit(){
      document.onkeydown = () => {
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
  },

  created() {
    this.keyupSubmit()
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .el-button + .el-button
    margin-left: 0
  .table-header
    margin-bottom 12px
  .el-input-group__prepend, .el-input-group__append
    background #ffffff
    padding 0 12px
  .el-input-group__append
    color #ffffff
    background #1890ff
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .table-right
    float right
  .changeBtn
    display: flex
    flex-direction: row
    width: 1110px
  // .demo-form-inline
  //   padding-top: 20px
  .iconBtns
    font-size 20px
    color rgba(0, 183, 158, 1)
  .el-form--inline .el-form-item
    margin-right: 30px
  // .table-search
  //   height: 36px
</style>
